import React, { useState, useEffect } from 'react'
import qs from 'qs';
import { TextField } from '@material-ui/core';
import './CustomerDetails.css';
import MaterialTable from 'material-table';
import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';
import { usePromiseTracker } from 'react-promise-tracker';
import config from '../utility/config';
// import pagination from "@material-ui/lab"
//import ajax from '../utility/ajax';

function CustomerDetails(props) {

    var queryParams = qs.parse(props.location.search,{ignoreQueryPrefix:true});

    var customerKey = queryParams.customerKey;
    var email = queryParams.customerEmail;

    const param = { 'email': email,
                    'customerKey': customerKey
                }
    const token = localStorage.getItem('idToken');

    const [data, setData] = useState([]);
    // const [details, setDetails] = useState([]);
    const [license, setLicense] = useState([]);
    const [payment, setPayment] = useState([]);
    const [backup, setBackup] = useState([]);
    const [audit, setAudit] = useState([]); 
    // const [columnsLicense,setColumns] = useState([]);   
    const { promiseInProgress } = usePromiseTracker();

    function toTitleCase(str) {
        str.replace("_"," ");
        return str.replace(
          /\w\S*/g,
          function(txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
          }
        );
      }
    const columnsLicense = [
        { title: "customer_id", field: "customer_id" },
        { title: "license_type", field: "license_type" },
        { title: "license_plan_name", field: "license_plan_name" },
        { title: "license_purchase_date", field: "license_purchase_date" },
        { title: "license_expiry_date", field: "license_expiry_date" },
        { title: "total_transactions", field: "total_transactions" },
        { title: "total_sms_allowed", field: "total_sms_allowed" },
        { title: "total_email_allowed", field: "total_email_allowed" },
        { title: "sms_remaining", field: "sms_remaining" },
        { title: "email_remaining", field: "email_remaining" },
        { title: "no_of_users", field: "no_of_users" },
        { title: "no_of_transactions_remaining", field: "no_of_transactions_remaining" },
        { title: "no_of_users_remaining", field: "no_of_users_remaining" },
        { title: "support_license_requested", field: "support_license_requested" },
        { title: "support_expiry_date", field: "support_expiry_date" },
        { title: "telephony_credits", field: "telephony_credits" },
        { title: "is_multisite_plan_requested", field: "is_multisite_plan_requested" },
        { title: "no_of_sp", field: "no_of_sp" },
        { title: "is_actual_license", field: "is_actual_license" },
        { title: "total_ivr_allowed", field: "total_ivr_allowed" },
        { title: "ivr_remaining", field: "ivr_remaining" },
        { title: "subsites", field: "subsites" },
        { title: "instances", field: "instances" }
    ]
   const columnsPayment = [
        { title: "customer_id", field: "customer_id" },
        { title: "amount", field: "amount" },
        { title: "netAmount", field: "net_amount" },
        { title: "response_code", field: "response_code" },
        { title: "response_reason_code", field: "response_reason_code" },
        { title: "response_reason_text", field: "response_reason_text" },
        { title: "first_name", field: "first_name" },
        { title: "address", field: "address" },
        { title: "zip", field: "zip" },
        { title: "user_units", field: "user_units" },
        { title: "user_price", field: "user_price" },
        { title: "description", field: "description" },
        { title: "payment_plan", field: "payment_plan" },
        { title: "payment_plan_desc", field: "payment_plan_desc" },
        { title: "is_multisite_plugin_requested", field: "is_multisite_plugin_requested" },
        { title: "no_of_sp", field: "no_of_sp" },
        { title: "payment_timestamp", field: "payment_timestamp" },
        { title: "subsites", field: "subsites" },
        { title: "instances", field: "instances" },
        { title: "Quote_number", field:"quote_number"},
    ]
    const columnsBackup = [
        { title: "code", field: "code" },
        { title: "expired", field: "expired" },
        { title: "hostname", field: "hostname" },
        { title: "created_dttm", field: "created_dttm" },
        { title: "last_updated_dttm", field: "last_updated_dttm" }
    ]
    const columnsAudit = [
        { title: "code", field: "code" },
        { title: "hostname", field: "hostname" },
        { title: "request_type", field: "request_type" },
        { title: "status", field: "status" },
        { title: "status_message", field: "status_message" },
        { title: "created_dttm", field: "created_dttm" }
    ]


    useEffect(() => {
      var csrf_token = localStorage.getItem('csrf_token');      
     trackPromise(
axios.post(config.drupal_url + '/api_service/customer_resource?_format=json', param, { headers: { Authorization: "Bearer " + token,'X-CSRF-Token': csrf_token } }).
        //axiosApp.post('/api_service/customer_resource', param, { headers: { Authorization: "Bearer " + token } }).
        then(res => {
            //console.log(res)
            setLicense(res.data.data.license);
            setPayment(res.data.data.payment)
            setBackup(res.data.data.backup)
            setAudit(res.data.data.audit)
        })
        .catch(err => {
            console.log(err)
        }))
    }, [])

    const [rowsPerPage, setRowsPerPage] = useState(5);
    //updates pagination, but no re-size
    const handleChangeRowsPerPage = event => {
      //enable to set rows per page to match total count
      event.target.value === "All"
        ? setRowsPerPage(5)
        : setRowsPerPage(event.target.value);
    }; 

    return !promiseInProgress && (
        <div>
            &nbsp;
            <link
                rel="stylesheet"
                href="https://fonts.googleapis.com/icon?family=Material+Icons"
            />
            <TextField className="textip"
                    label="Customer details for:"
                    name="customerid"
                    color="secondary"
                    variant="filled"
                    style={{ width: '40%' }}
                    type="text"
                    value={email}
            />
            <br/><br/><br/>
            <hr className='hrcss' /> 
            <div className="CustomerTable">
                <MaterialTable
                    title="Customer Licenses"
                    data={license}
                    columns={columnsLicense}
                    options={{
                        headerStyle: { position: 'sticky', top: 0 },
                            // maxBodyHeight: 100,
                            search: false,
                            paging: false,
                            filtering: true
                       }}
                       
                />&nbsp;<br/>
                <MaterialTable
                    title="License Payment Audit"
                    data={payment}
                    columns={columnsPayment}
                    options={{
                        headerStyle: { position: 'sticky', top: 0 },
                            // maxBodyHeight: 500,
                            search: false,
                            paging: false,
                            filtering: true
                       }}
                />&nbsp;<br/>
                <MaterialTable
                    title="Backup Code"
                    data={backup}
                    columns={columnsBackup}
                    options={{
                        headerStyle: { position: 'sticky', top: 0 },
                            // maxBodyHeight: 500,
                            search: false,
                            paging: false,
                            filtering: true
                       }}
                />&nbsp;<br/>
                <MaterialTable
                    title="Backup Code Audit"
                    data={audit}
                    columns={columnsAudit}
                    options={{
                        headerStyle: { position: 'sticky', top: 0 },
                            // maxBodyHeight: 500,
                            search: false,
                            paging: true,
                            filtering: true
                       }}
                />       
            </div>
        </div>
    )
}

export default CustomerDetails
